export default [
  
  {
    title: 'Tracking',
    icon: 'MapPinIcon',
    name:"dashboard",
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Paths Tracking',
        name: 'get.containers.paths',
        route: 'get.containers.paths',
        icon: 'MapPinIcon',
        meta: {
          module: 'live'
        }
      },
      {
        title: 'Containers Tracking',
        name: 'get.map.containers',
        route: 'get.map.containers',
        icon: 'MapPinIcon',
        meta: {
          module: 'live'
        }
      },
      {
        title: 'Live Tracking',
        name: 'tracking.live',
        route: 'tracking.live',
        icon: 'MapPinIcon',
        meta: {
          module: 'live'
        }
      },


      {
        title: 'Historical Tracking',
        name: 'tracking.history',
        route: 'tracking.history',
        icon: 'MapPinIcon',
        meta: {
          module: 'history'
        }
      },
]
}
]
